<template>
  <b-row>
    <b-col cols="12" sm="12">
      <b-card class="mx-auto" tile>
        <InputBuscar :filter="filter" @input="filter = $event">
          <BotonAgregar 
            @mostrarModalAgregar="mostrarModalAgregarModelo" 
            :textoBoton="$t('vModelo.agregarModelo')"
            :iconBoton="iconBoton"/>
        </InputBuscar>
        <b-row>
          <div class="col-md-12">
            <BaseTable
              tableClass="tblmodelos tabla-modelos"
              :items="modelos"
              :fields="headers"
              :currentPage="currentPage"
              :perPage="perPage"
              :filter="filter"
              @filtered="onFiltered"
              :total-rows="totalRows">
              <template #cell(Acciones)="data">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="p-1" v-if="data.item.id !== modelo.id">
                    <b-form-checkbox
                      switch
                      size="sm"
                      v-model="data.item.habilitado"
                      @click.native="showAlert(data.item)"
                      v-b-tooltip.hover="hoverHabilitado(data.item.habilitado)">
                    </b-form-checkbox>
                  </div>
                  <div class="p-1">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="mostrarModalEditarModelo(data.item)" v-b-tooltip.hover :title="$t('Gral.editar')">
                      <feather type="edit" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                </div>
              </template>
            </BaseTable>
          </div>
        </b-row>
      </b-card>
    </b-col>
    <template>
      <ModalAgregarModelo 
        ref="modalAgregarModelo" 
        @actualizarTabla="actualizarTabla"/>
    </template>
    <template>
      <ModalEditarModelo 
        ref="modalEditarModelo" 
        :datosModelo="datosModelo" 
        @actualizarTabla="actualizarTabla"/>
    </template>
  </b-row>
</template>

<script>
import ModelosDataService from "../../../services/ModelosDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from "../../../services/Crypto";

import ModalAgregarModelo from "./ModalAgregarModelo.vue";
import ModalEditarModelo from "./ModalEditarModelo.vue";
import BaseTable from "../../components/BaseTable.vue";
import InputBuscar from "../../components/InputBuscar.vue";
import BotonAgregar from "../../components/BotonAgregar.vue";

import { verificarAcceso } from '../../../utils/Session';

export default {
  name: "modelos",
  components: {
    ModalAgregarModelo,
    ModalEditarModelo,
    BaseTable,
    InputBuscar,
    BotonAgregar
  },
  data() {
    return {
      modelos: [],
      modelo: {
        id: 0,
        nombre: "",
        marca: "",
        habilitado: false,
      },
      datosModelo: {},
      title: "",
      filter: null,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      headers: [
        {
          key: "nombre",
          label: "Modelo",
          sortable: true,
        },
        {
          key: "marca.marca",
          label: "Marca",
          sortable: true,
        },
        {
          key: "Acciones",
          label: "Acciones",
          class: "largo-columna-acciones",
        },
      ],
      totalRows: 10,
      currentPage: 1,
      perPage: 10,
      filterOn: [],
      key: "",
      iconBoton: 'folder-plus',
    };
  },
  beforeCreate() {
    verificarAcceso();
    if (
      !sessionStorage.getItem("rol") ||
      sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL ||
      sessionStorage.idRol === process.env.VUE_APP_ID_ADMINISTRADOR
    ) {
      this.$router.push({
        path: "/monitoreo",
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: this.$t('vDispositivos.noPermisos'),
      });
    }
  },
  mounted() {
    this.key = sessionStorage.getItem('key')

    this.$nextTick(() => {
      this.obtenerModelos();
    });
  },
  methods: {

    mostrarModalAgregarModelo(){
      this.$refs.modalAgregarModelo.showModal();
    },

    mostrarModalEditarModelo(modelo){
      this.datosModelo = {... modelo};
      
      this.$nextTick(() => {
        this.$refs.modalEditarModelo.showModal();
      });
    },

    actualizarTabla(){
      this.obtenerModelos();
    },

    obtenerModelos() {
      ModelosDataService.getAll().then(async (response) => {
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.modelos = decoded.map(this.getDisplayModelo);
        this.totalRows = this.modelos.length;
      });
    },

    getDisplayModelo(modelo) {
      return {
        id: modelo.id,
        nombre: modelo.modelo,
        marca: modelo.marca,
        habilitado: modelo.habilitado,
      };
    },
  
    showAlert(datos) {
      let habilitarTranslate = "";
      let habilitarAccion = "";
      if (datos.habilitado === true) {
        habilitarTranslate = this.$t("Gral.des");
        habilitarAccion = "desh";
      } else {
        habilitarTranslate = this.$t("Gral.h");
        habilitarAccion = "h";
      }

      this.$swal({
        text: this.$t("vModelo.msgHabilitar", { frase: habilitarTranslate }),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: this.$t("Gral.aceptar"),
        cancelButtonText: this.$t("Gral.cancelar"),
        iconColor: "red",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.setItem("idModelo", datos.id);
          ModelosDataService.delete(this.key).then((response) => {
            if (response.status == 200) {
              this.accion = this.accion = "Ha " + habilitarAccion + "abilitado el modelo " + datos.nombre;
              this.registrarAccion();
              this.obtenerModelos();
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "success",
                title: this.$t("vModelo.msgHabilitarToast", {
                      frase: habilitarTranslate,
                }),
              });
            }
          });
        } else {
          datos.habilitado = !datos.habilitado;
        }
      });
    },
    
    hoverHabilitado(hab) {
      if (hab) return this.$t("Gral.deshabilitar");
      else return this.$t("Gral.habilitar");
    },

    registrarAccion() {
      const data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems
      this.currentPage = 1
    }
  }
};
</script>

<style>
.largo-columna-acciones {
  width: 200px;
}

@media (max-width: 959px) {
 .boton-limpiar, .boton-agregar{
  margin-top: -16px;
 }

 .tabla-modelos{
  margin-top: -8px;
 }
}

@media (min-width: 960px) {
 .boton-limpiar, .boton-agregar{
  margin-top: 0px !important;
 }
}

@media only screen and (max-width: 1600px) {
  .largo-columna-acciones {
    width: 200px;
  }
}

@media screen and (max-width: 991px) {
  .largo-columna-acciones {
    width: 200px;
  }
}

@media screen and (max-width: 767px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media screen and (max-height: 450px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {
  /* Force table to not be like tables anymore */
  .tblmodelos table,
  .tblmodelos thead,
  .tblmodelos tbody,
  .tblmodelos th,
  .tblmodelos td,
  .tblmodelos tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .tblmodelos thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tblmodelos tr {
    border: 1px solid #ccc;
  }

  .tblmodelos td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 5%;
    text-align: left;
  }

  .tblmodelos td:after {
    /* Now like a table header */
    position: relative;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 70%;
    padding-right: 10px;
    white-space: nowrap;
  }
  /*
	Label the data
	*/

  .tblmodelos td:first-child:before {
    content: "Modelo: ";
  }
  .tblmodelos td:nth-of-type(2):before {
    content: "Marca: ";
  }
  .tblmodelos td:last-child:before {
    content: "Acciones: ";
  }
}

.vertical-center {
  min-height: 100%; /* Fallback for browsers do NOT support vh unit */
  min-height: 100vh; /* These two lines are counted as one :-)       */

  display: flex;
  align-items: center;
}
</style>
